/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type UserSignature = {
    readonly url?: string;
    password: string;
    email: string;
    user_type?: UserSignature.user_type;
    first_name: string;
    last_name: string;
    username: string;
    contact_number: string;
    address: string;
    pin_code: string;
    city: string;
    readonly date_joined?: string;
    last_login?: string | null;
    is_email_verified_by_user?: boolean;
    email_confirmation_mail_sent_on?: string | null;
    account_activation_mail_sent_to_admin?: string | null;
    account_activation_replied_by_admin?: string | null;
    deactivated_on?: string | null;
    readonly next_password_change_at?: string;
    is_active?: boolean;
    gsx_technician_id: string;
    gsx_user_name: string;
    gsx_auth_token: string;
    gsx_ship_to?: string;
    gsx_token_last_refreshed_on?: string | null;
    is_admin?: boolean;
    readonly user_signature?: string | null;
};

export namespace UserSignature {

    export enum user_type {
        '_1' = 1,
        '_2' = 2,
        '_3' = 3,
        '_4' = 4,
        '_5' = 5,
    }


}
